export default "__VITE_ASSET__BZjE_I8h__"